import React from 'react';
import { Edit, TabbedForm, FormTab, List } from 'react-admin';
import { FormSpy } from 'react-final-form';
import { withStyles } from '@material-ui/core/styles';
import FormTitleBar from '../../core/components/FormTitleBar';
import EditToolbar from '../../core/components/edit/EditToolbar';
import { removePathEnd, getInitials } from '../../core/utils';
import NavigationPrompt from '../../core/components/NavigationPrompt';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import RelatedContactsDatagrid from './RelatedContactsDatagrid';
import RoleSummary from './RoleSummary';
import { makeStyles } from '@material-ui/core';
import { Grid, Typography } from '@material-ui/core/';
import Empty from '../../core/components/list/Empty';
import ViewTab from '../../core/components/forked/layout/ViewTab';

const styles = () => ({
  gridTab: {
    marginTop: '-17px !important'
  },
  noActions: {
    marginTop: '0px'
  }
});

const RoleTitle = ({ record }) => {
  return (
    <FormTitleBar
      name={record.description}
      showAvatar={true}
      avatarContent={getInitials(record.description)}
    />
  );
};

const useStyles = makeStyles({
  headerContainer: {
    paddingTop: '8px'
  }
});
const RelatedContactsLabel = ({ label }) => {
  const classes = useStyles();

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="h5" className={classes.headerContainer}>
          {label}
        </Typography>
      </Grid>
    </Grid>
  );
};

class RoleEdit extends React.Component {
  state = {
    whenBlockNavigation: false
  };

  onBeforeDelete = () => {
    // Unblock navigation before deleting
    this.setState({
      whenBlockNavigation: false
    });
  };

  handleFormIsDirty(dirty) {
    // Block navigation if the form is dirty
    this.setState({ whenBlockNavigation: dirty });
  }

  render() {
    const { whenBlockNavigation } = this.state;
    const {
      classes,
      permissions = [],
      hasEditPermission,
      hasDeletePermission,
      hasCreatePermission,
      userProfile,
      ...rest
    } = this.props;
    const displayToolbar = this.props.match.isExact;
    const hasReadUserRolePermission = permissions.includes(
      'AUTH_READ_USER_ROLE'
    );

    return (
      <React.Fragment>
        <NavigationPrompt
          when={whenBlockNavigation}
          adjustMatchingPath={removePathEnd}
          hasEditPermission={hasEditPermission}
        >
          {(isOpen, onConfirm, onCancel) => (
            <LeaveConfirm
              isOpen={isOpen}
              onConfirm={onConfirm}
              onClose={onCancel}
            />
          )}
        </NavigationPrompt>
        <Edit
          {...rest}
          undoable={false}
          title={<RoleTitle />}
          classes={{ noActions: classes.noActions }}
        >
          <TabbedForm
            toolbar={
              displayToolbar ? (
                <EditToolbar
                  {...rest}
                  hasEditPermission={hasEditPermission}
                  hasDeletePermission={hasDeletePermission}
                  onBeforeDelete={this.onBeforeDelete}
                />
              ) : (
                <></>
              )
            }
            variant="standard"
            margin="normal"
          >
            <FormTab label="Details">
              <RoleSummary variant="standard" creation={false} />
              <FormSpy
                subscription={{ dirty: true }}
                onChange={props => {
                  const self = this;
                  setTimeout(() => self.handleFormIsDirty(props.dirty), 1);
                }}
              />
            </FormTab>
            {hasReadUserRolePermission && (
              <ViewTab label="Related Contacts">
                <RelatedContactsLabel label="Related Contacts" />
                <List
                  style={{ margin: '0px', width: '100%' }}
                  pagination={false}
                  exporter={false}
                  actions={<></>}
                  resource="userroles"
                  basePath="/userroles"
                  className={classes.gridTab}
                  filter={{ roleId: this.props.id }}
                  title=" "
                  empty={
                    <Empty
                      emptyText="There are no related contacts to be displayed"
                      title=" "
                    />
                  }
                >
                  <RelatedContactsDatagrid permissions={permissions} />
                </List>
              </ViewTab>
            )}
          </TabbedForm>
        </Edit>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(RoleEdit);
